/**
 * Kinde Authentication Configuration
 * Provides Kinde provider configuration for React application
 * 
 * Usage: Wrap your app with KindeProvider in main.tsx
 */

// Kinde configuration object
export const kindeConfig = {
  clientId: import.meta.env.VITE_KINDE_CLIENT_ID || '',
  domain: import.meta.env.VITE_KINDE_DOMAIN || '',
  redirectUri: import.meta.env.VITE_KINDE_REDIRECT_URI || window.location.origin,
  logoutUri: import.meta.env.VITE_KINDE_LOGOUT_URI || window.location.origin,
};

// Validate configuration
if (!kindeConfig.domain || !kindeConfig.clientId) {
  console.warn(
    'Kinde configuration missing. Please set VITE_KINDE_DOMAIN and VITE_KINDE_CLIENT_ID in .env',
  );
}

